module.exports = __webpack_public_path__ + "static/media/theMofG27.53b93bc7.png";